import CardSection from "../../../../conponents/CardSection/CardSection";
import ImagePicker from "../../../../conponents/ImagePicker/ImagePicker";

import styles from "./ProfileImageSection.module.css";

const ProfileImageSection = ({

    values,

    setFieldValue,

}) => {

    return (

        <CardSection title="تصویر پروفایل">

            <div className={styles.wrapper}>

                <ImagePicker

                    label="انتخاب تصویر"

                    value={values.imageFile}

                    preview={values.imageUrl}

                    showPreview={true}

                    onChange={(file)=>

                        setFieldValue(

                            "imageFile",

                            file

                        )

                    }

                />

            </div>

        </CardSection>

    );

};

export default ProfileImageSection;